import { call, takeLatest } from "redux-saga/effects";
import { Actions } from "../constants/actionTypes";
import {
  apiSendFeedback,
  apiSendInvite,
} from "../Services/support/supportAPI.js";

export function* sendInviteToHelpCenter() {
  yield takeLatest([Actions.API_SEND_INVITE_TO_HELP_CENTER], sendInvite);
}

function* sendInvite(action) {
  const result = yield call(apiSendInvite);
  if (result.isApiSuccessful) {
    action.meta.onSuccess(result.data);
  } else {
    action.meta.onError();
  }
  return result;
}

export function* sendFeedback() {
  yield takeLatest([Actions.API_SEND_FEEDBACK], sendFeedbackAction);
}

function* sendFeedbackAction(action) {
  const result = yield call(apiSendFeedback, action);
  if (result.isApiSuccessful) {
    action.meta?.onSuccess();
  } else {
    action.meta?.onError();
  }
  return result;
}
